import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Orders Module Service Stores
 * Services for customer order management
 */
export const ordersStores: ServiceStoreConfig[] = [
  {
    name: "customer-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.customerOrdersStore as {
            entities?: unknown[];
          };
          const entities = store?.entities || [];
          const totalOrders = entities.length;
          const todayOrders = entities.filter(
            (order: Record<string, unknown>) => {
              const orderDate = new Date(order.createdAt as string);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              return orderDate >= today;
            }
          ).length;
          const pendingOrders = entities.filter(
            (order: Record<string, unknown>) =>
              order.status === "pending" || order.status === "processing"
          ).length;
          const completedOrders = entities.filter(
            (order: Record<string, unknown>) =>
              order.status === "completed" || order.status === "delivered"
          ).length;

          return [
            {
              title: "Total Orders",
              value: () => totalOrders.toString(),
              valueColor: "primary.main",
              variant: "with-icon" as const,
            },
            {
              title: "Today",
              value: () => todayOrders.toString(),
              valueColor: "info.main",
            },
            {
              title: "Pending",
              value: () => pendingOrders.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Completed",
              value: () => completedOrders.toString(),
              valueColor: "success.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["createdAt"],
          sortDirection: { createdAt: "DESC" },
        },
        actions: {
          onRowClick: (row) => {
            console.log("View order:", row.orderId);
          },
          onRowDoubleClick: (row, rootStore) => {
            rootStore.routerStore?.openDialog({
              dialogName: "orderDetail",
              dialogContext: `${row.orderId}`,
            });
          },
        },
      },
    },
  },
];